import type { ConceptScope, FieldKey, Recency } from "@/types/concept";

// Mirrors backend core/scope.FIELD_GROUPS (pinned by tests/test_scope_fe_contract.py).
export const FIELD_GROUPS: Record<
  FieldKey,
  { label: string; s2Fields: string[]; defaults: { recency: Recency; yearsBack?: number; yearMin?: number } }
> = {
  humanities: {
    label: "Humanities & Arts",
    s2Fields: ["Art", "History", "Philosophy", "Linguistics"],
    defaults: { recency: "classic" },
  },
  social: {
    label: "Social & Behavioural sciences",
    s2Fields: ["Psychology", "Sociology", "Political Science", "Economics", "Education", "Business", "Law", "Geography"],
    defaults: { recency: "balanced" },
  },
  life: {
    label: "Life sciences & Medicine",
    s2Fields: ["Medicine", "Biology", "Agricultural and Food Sciences"],
    defaults: { recency: "balanced", yearsBack: 20 },
  },
  physical: {
    label: "Physical sciences & Engineering",
    s2Fields: ["Physics", "Chemistry", "Materials Science", "Engineering", "Geology", "Mathematics", "Environmental Science"],
    defaults: { recency: "balanced" },
  },
  cs: {
    label: "Computer Science",
    s2Fields: ["Computer Science"],
    defaults: { recency: "recent", yearMin: 2015 },
  },
};

export const FIELD_KEYS = Object.keys(FIELD_GROUPS) as FieldKey[];

export function fieldFromS2(fields: (string | null | undefined)[] | null | undefined): FieldKey | null {
  for (const f of fields ?? []) {
    const key = FIELD_KEYS.find((k) => f && FIELD_GROUPS[k].s2Fields.includes(f));
    if (key) return key;
  }
  return null;
}

export function defaultScopeFor(field: FieldKey, now: Date = new Date()): ConceptScope {
  const d = FIELD_GROUPS[field].defaults;
  const scope: ConceptScope = { field, recency: d.recency };
  if (d.yearMin != null) scope.year_min = d.yearMin;
  if (d.yearsBack != null) scope.year_min = now.getFullYear() - d.yearsBack;
  return scope;
}

/** ②'s starting scope: the anchor paper's field, else the concept's, else balanced. */
export function initialScope(
  anchorFields: string[] | null | undefined, primaryField: string | null | undefined, now = new Date(),
): ConceptScope {
  const field = fieldFromS2(anchorFields) ?? fieldFromS2([primaryField]);
  return field ? defaultScopeFor(field, now) : { recency: "balanced" };
}

/** The scope PUT body: no undefined keys. */
export const cleanScope = (s: ConceptScope): ConceptScope =>
  Object.fromEntries(Object.entries(s).filter(([, v]) => v !== undefined)) as ConceptScope;
